<template>
  <van-popup v-model="show" round position="bottom" :style="{ height: 'auto', maxHeight: '70vh' }">
    <div style="padding: 20px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
        <div style="font-size: 18px; font-weight: bold;">{{ $t('report_message_title') }}</div>
        <van-icon name="cross" size="20" color="#999" @click="close" />
      </div>
      
      <div style="margin-bottom: 16px; color: #8A8A8A; font-size: 14px;">
        {{ $t('report_reason_prompt') }}
      </div>
      
      <van-radio-group v-model="selectedReason">
        <van-cell-group>
          <van-cell :title="$t('report_spam')" clickable @click="selectedReason = 'spam'">
            <van-radio slot="right-icon" name="spam" />
          </van-cell>
          <van-cell :title="$t('report_harassment')" clickable @click="selectedReason = 'harassment'">
            <van-radio slot="right-icon" name="harassment" />
          </van-cell>
          <van-cell :title="$t('report_inappropriate')" clickable @click="selectedReason = 'inappropriate'">
            <van-radio slot="right-icon" name="inappropriate" />
          </van-cell>
          <van-cell :title="$t('report_other')" clickable @click="selectedReason = 'other'">
            <van-radio slot="right-icon" name="other" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      
      <van-field
        v-if="selectedReason === 'other'"
        v-model="description"
        type="textarea"
        :placeholder="$t('placeholder_report_desc')"
        rows="3"
        style="margin-top: 16px;"
      />
      
      <div style="margin-top: 24px; display: flex; gap: 12px;">
        <van-button type="default" size="large" @click="close" style="flex: 1;">{{ $t('cancel') }}</van-button>
        <van-button type="primary" size="large" @click="submitReport" :loading="submitting" style="flex: 1; background: #E8543A; border-color: #E8543A;">
          {{ $t('submit') }}
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Vue from 'vue'
import { Popup, Icon, Radio, RadioGroup, Cell, CellGroup, Field, Button, Toast } from 'vant'
import axios from 'axios'

Vue.use(Popup)
Vue.use(Icon)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Button)
Vue.use(Toast)

export default {
  name: 'ReportDialog',
  data() {
    return {
      show: false,
      selectedReason: '',
      description: '',
      submitting: false,
      msgId: '',
      reportedUserId: ''
    }
  },
  methods: {
    open(msgId, reportedUserId) {
      this.msgId = msgId
      this.reportedUserId = reportedUserId
      this.selectedReason = ''
      this.description = ''
      this.show = true
    },
    close() {
      this.show = false
    },
    async submitReport() {
      if (!this.selectedReason) {
        Toast(this.$t('toast_select_reason'))
        return
      }
      
      this.submitting = true
      try {
        const response = await axios.post('/api/user/report_message', {
          reportedUserId: this.reportedUserId,
          msgId: this.msgId,
          reason: this.selectedReason,
          description: this.description
        })
        
        if (response.data.code === 0 && response.data.data.success) {
          Toast.success(this.$t('toast_report_success'))
          this.close()
        } else {
          Toast.fail(response.data.data.msg || this.$t('toast_report_failed'))
        }
      } catch (error) {
        console.error('Submit report error:', error)
        Toast.fail(this.$t('toast_report_failed'))
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportDialog.vue